<template>
  <Modal
    id="value-of-goods-modal"
    v-model:visible="isVisible"
    content-class="flex flex-column flex-gap-1"
    :header="t('common.valueOfGoods')"
    @keypress.esc="onCancel"
    @keypress.enter="onSave"
  >
    <p>{{ t('common.valueOfGoodsModalMessage') }}</p>

    <InputWrapper
      v-slot="{ ariaProps, inputId }"
      input-id="value-of-goods-modal-input"
      :label="t('common.valueOfGoods')"
    >
      <InputMoney
        :id="inputId"
        v-model="wrappedValue"
        v-bind="ariaProps"
        :placeholder="t('common.valueOfGoods')"
      />
    </InputWrapper>

    <template #footer>
      <RygenButton
        mode="tertiary"
        :label="t('common.cancel')"
        @click="onCancel"
      />
      <RygenButton
        mode="primary"
        icon="pi pi-save"
        :label="t('common.save')"
        @click="onSave"
      />
    </template>
  </Modal>
</template>

<script lang="ts" setup>
import { PropType, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';

import { Money } from '@rygen/rygen-ui/model';

import { MoneyUtil } from '@/util';

import RygenButton from '@rygen/rygen-ui/components/button/RygenButton.vue';
import InputMoney from '@rygen/rygen-ui/components/form/InputMoney.vue';
import InputWrapper from '@rygen/rygen-ui/components/form/InputWrapper.vue';
import Modal from '@rygen/rygen-ui/components/ui/Modal.vue';

const isVisible = defineModel('visible', {
  type: Boolean,
  default: () => false,
});

const valueOfGoods = defineModel('valueOfGoods', {
  type: Object as PropType<Money | undefined>,
  default: () => undefined,
});

const { t } = useI18n();

const wrappedValue = ref(MoneyUtil.clone(valueOfGoods.value));

const onCancel = () => {
  isVisible.value = false;
};

const onSave = () => {
  isVisible.value = false;
  valueOfGoods.value = wrappedValue.value;
};

watch(isVisible, (visible: boolean) => {
  if (visible) {
    //start from the current value so a cancelled or dismissed edit is discarded
    wrappedValue.value = MoneyUtil.clone(valueOfGoods.value);
  }
});
</script>
